import { render, staticRenderFns } from "./LocalDatePicker.vue?vue&type=template&id=08f5fb56&scoped=true&"
import script from "./LocalDatePicker.vue?vue&type=script&lang=js&"
export * from "./LocalDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./LocalDatePicker.vue?vue&type=style&index=0&id=08f5fb56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f5fb56",
  null
  
)

export default component.exports